export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) {
    return "Data não disponível"; // Mensagem padrão para valores nulos ou indefinidos
  }

  let parsedDate: Date;

  if (typeof date === "string") {
    const [year, month, day] = date.split("-");
    parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
  } else {
    parsedDate = date;
  }

  if (isNaN(parsedDate.getTime())) {
    return "Data inválida";
  }

  return `${parsedDate.getDate().toString().padStart(2, "0")}/${(
    parsedDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${parsedDate.getFullYear()}`;
  // const parsedDate = typeof date === "string" ? new Date(date) : date;

  // if (isNaN(parsedDate.getTime())) {
  //   return "Data inválida"; // Tratamento para datas inválidas
  // }

  // return `${parsedDate.getDate().toString().padStart(2, "0")}/${(
  //   parsedDate.getMonth() + 1
  // )
  //   .toString()
  //   .padStart(2, "0")}/${parsedDate.getFullYear()}`;
};
